import jwt from 'jwt-decode';

export function getDecodedToken(user) {
  if (!user || !user.idToken) return {};
  return jwt(user.idToken);
}

export function getProfileGroups(user, assumeuser) {
  if (!user || !user.idToken) return [];
  if (assumeuser !== null) return assumeuser.groups || [];
  return getDecodedToken(user)['cognito:groups'] || [];
}

export function getCognitoGroups(user) {
  if (!user || !user.idToken) return undefined;
  return getDecodedToken(user)['cognito:groups'];
}

export function getProfileFromToken(user) {
  if (!user || !user.idToken) {
    return {
      profileGroups: undefined,
      displayName: user?.username || '',
      email: '',
      initial: '?',
      picture: null,
    };
  }
  const profileToken = getDecodedToken(user);
  const profileGroups = profileToken['cognito:groups'];
  const displayName =
    profileToken['given_name'] === undefined
      ? user.username
      : profileToken['given_name'];
  const email = profileToken['email'] || '';
  const initial =
    (displayName && String(displayName).trim().charAt(0).toUpperCase()) || '?';
  const picture =
    typeof profileToken['picture'] === 'string' &&
    /^https?:\/\//i.test(profileToken['picture'])
      ? profileToken['picture']
      : null;

  return {
    profileGroups,
    displayName,
    email,
    initial,
    picture,
  };
}

export const CHAT_PERMISSION_GROUP = 'CHAT';

export function hasChatPermission(user, assumeuser) {
  return getProfileGroups(user, assumeuser).includes(CHAT_PERMISSION_GROUP);
}
